module.exports = __webpack_public_path__ + "static/media/choquinhas.20f68e50.mp3";